import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getPpmConfirmWorkflowObjectProps {
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getPpmConfirmWorkflowObject = ({ action, toggleVisiblity }: getPpmConfirmWorkflowObjectProps): DialogObject => {
  return {
    title: `Confirmation de passage pour validation`,
    description: 'Ce PPM sera passé pour validation, veuillez confirmer les modifications avant de continuer',
    actions: [
      {
        label: 'Passer pour validation',
        variant: 'info',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => {
          toggleVisiblity?.();
        },
        variant: 'secondary',
      },
    ],
  };
};
